export const Iban = {
    label: 'BNP Paribas - The Gator Projects',
    iban: 'FR76 3000 4008 3200 0103 4284 218',
    rib: '30004 00832 0010342842 18'
}

                   
                      
                 